import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export const StockDialog = ({ product, onClose, onSaved }) => {
  const [mode, setMode] = useState("in");
  const [qty, setQty] = useState("");
  const [note, setNote] = useState("");
  useEffect(() => { setMode("in"); setQty(""); setNote(""); }, [product]);
  if (!product) return null;
  const save = async (e) => {
    e.preventDefault();
    const n = parseInt(qty, 10);
    if (!n) return;
    try {
      await api.post(`/products/${product.id}/stock`, { qty: mode === "in" ? n : -n, note: note || (mode === "in" ? "Stok masuk" : "Stok keluar") });
      toast.success("Stok diperbarui");
      onSaved();
      onClose();
    } catch (e2) {
      toast.error(errMsg(e2));
    }
  };
  return (
    <Dialog open={!!product} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="stock-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Atur Stok</DialogTitle>
          <DialogDescription>{product.name} · stok saat ini <b className="font-mono">{product.stock}</b></DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <div className="grid grid-cols-2 gap-2">
            <Button type="button" variant={mode === "in" ? "default" : "outline"} onClick={() => setMode("in")} data-testid="stock-mode-in">Stok Masuk</Button>
            <Button type="button" variant={mode === "out" ? "destructive" : "outline"} onClick={() => setMode("out")} data-testid="stock-mode-out">Stok Keluar</Button>
          </div>
          <div className="space-y-1.5"><Label>Jumlah</Label><Input autoFocus inputMode="numeric" className="font-mono" value={qty} onChange={(e) => setQty(e.target.value.replace(/\D/g, ""))} data-testid="stock-qty-input" /></div>
          <div className="space-y-1.5"><Label>Keterangan</Label><Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="cth: pembelian supplier" data-testid="stock-note-input" /></div>
          <Button type="submit" className="w-full" data-testid="stock-save-btn">Simpan</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
